import { useState, useEffect } from 'react'
import { ThemeProvider } from './contexts/ThemeContext'
import Header from './components/Header'
import Hero from './components/Hero'
import About from './components/About'
import Experience from './components/Experience'
import Projects from './components/Projects'
import Skills from './components/Skills'
import Footer from './components/Footer'
import Contact from './components/Contact'
import SEOHead from './components/SEOHead'
import ErrorBoundary from './components/ErrorBoundary'
import { initGA } from './utils/analytics'
import { usePageTracking, usePerformanceTracking, useEngagementTracking } from './hooks/useAnalytics'

function App() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)

  // Initialize analytics and tracking
  usePageTracking('Portfolio')
  usePerformanceTracking()
  useEngagementTracking()

  useEffect(() => {
    // Initialize Google Analytics
    initGA()
  }, [])

  return (
    <ErrorBoundary>
    <ThemeProvider>
      <SEOHead />
      <div className="min-h-screen bg-white dark:bg-slate-900 transition-colors duration-300">
        <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        
        <main>
          <section id="home">
            <Hero />
          </section>
          
          <section id="about">
            <About />
          </section>
          
          <section id="experience">
            <Experience />
          </section>
          
          <section id="projects">
            <Projects />
          </section>
          
          <section id="skills">
            <Skills />
          </section>
          
          <section id="contact">
            <Contact />
          </section>
        </main>
        
        <Footer />
      </div>
    </ThemeProvider>
    </ErrorBoundary>
  )
}

export default App